import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { ApplicationState } from "../store";
import { withRouter, RouteComponentProps } from "react-router";
import { actions } from "../store/Footer";
import { FooterBase } from "./FooterBase";

const Footer: React.FC<FooterProps> = (props: FooterProps) => {
  return (
    <FooterBase
      title={props.title}
      price={props.price}
      totalPriceTooltip={props.totalPriceTooltip}
      purchaseButton={props.purchaseButton}
      expanded={props.expanded}
      prices={props.prices}
      footerExpanded={props.footerExpanded}
      secondaryPrice={props.secondaryPrice}
      showSecondaryPrice={props.showYearlyPrice}
    />
  );
};

const connector = connect((state: ApplicationState) => state.footer, {
  footerExpanded: actions.footerExpanded,
});

type FooterProps = ConnectedProps<typeof connector> & RouteComponentProps & { showYearlyPrice?: boolean };

export default withRouter(connector(Footer));
